import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconExchange from '@/icons/Exchange.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingExchangeStockAvailabilityConfirmationNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_exchange_stock_availability_confirmation'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const stockLocationName = notification.data.onBehalfOfWorkshop?.name;

  return (
    <BaseNotification
      notificationLabel={
        notification.data.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-exchange-stock-availability-confirmation.label.on-behalf',
              message: `Stock availability confirmation required for request ${requestReference} on behalf of ${stockLocationName}`,
            })
          : t({
              id: 'notification.pending-exchange-stock-availability-confirmation.label',
              message: `Stock availability confirmation required for request ${requestReference}`,
            })
      }
      icon={<IconExchange />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-exchange-stock-availability-confirmation.on-behalf">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new stock availability request to confirm on behalf of{' '}
            <InlineText weight="medium" color={color}>
              {stockLocationName}
            </InlineText>
          </Trans>
        ) : (
          <Trans id="notification.pending-exchange-stock-availability-confirmation">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new stock availability request to confirm
          </Trans>
        )
      }
    />
  );
};
